module.exports = __webpack_public_path__ + "img/2_opacity.f1919b62.png";